import { type FolderChildType } from '@store/api/folderEndpoints';
import { thumbnailCache, useLazyGetProjectThumbnailQuery } from '@store/api/projectEndpoints';
import { FolderClosed } from 'lucide-react';
import { useEffect, useState } from 'react';
import { CubeIcon } from 'react-line-awesome';

interface ThumbnailCellProps {
  type: FolderChildType;
  projectId: string;
}

const Thumbnail = ({ type, projectId }: ThumbnailCellProps) => {
  const [thumbnailUrl, setThumbnailUrl] = useState<string | null>(null);
  const [getProjectThumbnail, { isLoading, isError }] = useLazyGetProjectThumbnailQuery();

  useEffect(() => {
    const fetchThumbnail = async () => {
      const cachedThumbnail = thumbnailCache.get(projectId);

      if (cachedThumbnail !== undefined) return setThumbnailUrl(cachedThumbnail);

      const { data } = await getProjectThumbnail(projectId);

      setThumbnailUrl(data ?? null);
      thumbnailCache.set(projectId, data ?? null);
    };

    if (type == 'Project') fetchThumbnail();

  }, [projectId, getProjectThumbnail, type]);

  if (type == 'Folder') {
    return <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
      <FolderClosed size='46px' style={{ color: 'antiquewhite' }} />
    </div>;
  }

  if (isLoading) return <div style={{ width: '100%', height: '100%' }} />;

  if (isError || thumbnailUrl == null) {
    return <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
      <CubeIcon size='4x' style={{ color: 'white' }} />
    </div>;
  }

  return (
    <div
      style={{
        backgroundImage: thumbnailUrl ? `url(${thumbnailUrl})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '65px',
        width: '110px',
        cursor: thumbnailUrl ? 'pointer' : 'default',
      }}
    />
  );
};

export default Thumbnail;
